"use client";

import { Divider } from "@getgrover/ui";
import { useTranslations } from "next-intl";
import { showPreferences } from "vanilla-cookieconsent";
import { Copyright, FooterContainer, LinksWrapper, StyledLink } from "./styles";
import { getCopyright, useFooterLinks } from "./utils";

export const Footer = ({
  hasBottomSpacing = false,
}: {
  hasBottomSpacing?: boolean;
}) => {
  const copyright = getCopyright();
  const t = useTranslations("footer.links");
  const footerLinks = useFooterLinks();

  return (
    <footer>
      <FooterContainer $hasBottomSpacing={hasBottomSpacing}>
        <Divider />
        <LinksWrapper>
          <StyledLink onClick={showPreferences} href="#">
            {t("cookie_settings")}
          </StyledLink>
          {footerLinks.map((link) => (
            <StyledLink key={link.text} href={link.url}>
              {t(
                link.text as
                  | "imprint"
                  | "privacy_policy"
                  | "terms_and_conditions",
              )}
            </StyledLink>
          ))}
        </LinksWrapper>
        <Copyright>{copyright}</Copyright>
      </FooterContainer>
    </footer>
  );
};
